/*协议*/
import getTranslation from '@/locale/getTranslation'
export default {
  path: '/rule',
  name: 'rule',
  component: resolve => require(['@/views/rule'], resolve),
  meta: {
    title: '规则协议'
  },
  children: [
    {
      path: '/',
      redirect: 'permission'
    },
    {
      path: 'collection',
      name: 'collection',
      component: resolve => require(['@/views/rule/collection'], resolve),
      meta: {
        title: getTranslation('个人信息收集清单'),
        keepAlive: true
      }
    },
    {
      path: 'sharing',
      name: 'sharing',
      component: resolve => require(['@/views/rule/sharing'], resolve),
      meta: {
        title: getTranslation('个人信息共享清单'),
        keepAlive: true
      }
    },
    {
      path: 'privacy',
      name: 'privacy',
      component: resolve => require(['@/views/rule/privacy'], resolve),
      meta: {
        title: getTranslation(`隐私政策（简要版）`),
        keepAlive: true
      }
    },
    {
      path: 'permission',
      name: 'permission',
      component: resolve => require(['@/views/rule/permission'], resolve),
      meta: {
        title: getTranslation('应用权限申请与使用情况说明'),
        keepAlive: true
      }
    },
    {
      path: '*',
      redirect: 'permission'
    }
  ]
}
